import React from "react";

import "./styles.css";

const CityBadge = () => {
  return (
    <div className="badge">
      <div className="bird" id="bird-1"></div>
      <div className="bird" id="bird-2"></div>
      <div id="full-cloud-1" className="cloud">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 612 338.2"
        >
          <g>
            <path
              d="M527.3,168c-16.9,0-32.6,5-45.9,13.5c0.5-5.4,0.8-10.9,0.8-16.4C482.2,73.9,409.7,0,320.2,0
		c-72.8,0-134.4,48.9-154.8,116.2c-2.4-0.2-4.8-0.4-7.2-0.4c-57,0-103.2,47.1-103.2,105.2c0,1.8,0.2,3.6,0.3,5.3c-0.1,0-0.2,0-0.3,0
		c-30.3,0-54.9,25-54.9,55.9s24.6,55.9,54.9,55.9c0.7,0,1.4-0.1,2.1-0.1h470.3c47,0,85-38.1,85-85C612.3,206.1,574.3,168,527.3,168z
		"
            />
          </g>
        </svg>
      </div>
      <div id="full-cloud-2" className="cloud">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 612 338.2"
        >
          <g>
            <path
              d="M527.3,168c-16.9,0-32.6,5-45.9,13.5c0.5-5.4,0.8-10.9,0.8-16.4C482.2,73.9,409.7,0,320.2,0
		c-72.8,0-134.4,48.9-154.8,116.2c-2.4-0.2-4.8-0.4-7.2-0.4c-57,0-103.2,47.1-103.2,105.2c0,1.8,0.2,3.6,0.3,5.3c-0.1,0-0.2,0-0.3,0
		c-30.3,0-54.9,25-54.9,55.9s24.6,55.9,54.9,55.9c0.7,0,1.4-0.1,2.1-0.1h470.3c47,0,85-38.1,85-85C612.3,206.1,574.3,168,527.3,168z
		"
            />
          </g>
        </svg>
      </div>
      <div id="full-cloud-3" className="cloud">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 612 338.2"
        >
          <g>
            <path
              d="M527.3,168c-16.9,0-32.6,5-45.9,13.5c0.5-5.4,0.8-10.9,0.8-16.4C482.2,73.9,409.7,0,320.2,0
		c-72.8,0-134.4,48.9-154.8,116.2c-2.4-0.2-4.8-0.4-7.2-0.4c-57,0-103.2,47.1-103.2,105.2c0,1.8,0.2,3.6,0.3,5.3c-0.1,0-0.2,0-0.3,0
		c-30.3,0-54.9,25-54.9,55.9s24.6,55.9,54.9,55.9c0.7,0,1.4-0.1,2.1-0.1h470.3c47,0,85-38.1,85-85C612.3,206.1,574.3,168,527.3,168z
		"
            />
          </g>
        </svg>
      </div>
      <div id="full-cloud-4" className="cloud red">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 612 338.2"
        >
          <g>
            <path
              d="M527.3,168c-16.9,0-32.6,5-45.9,13.5c0.5-5.4,0.8-10.9,0.8-16.4C482.2,73.9,409.7,0,320.2,0
		c-72.8,0-134.4,48.9-154.8,116.2c-2.4-0.2-4.8-0.4-7.2-0.4c-57,0-103.2,47.1-103.2,105.2c0,1.8,0.2,3.6,0.3,5.3c-0.1,0-0.2,0-0.3,0
		c-30.3,0-54.9,25-54.9,55.9s24.6,55.9,54.9,55.9c0.7,0,1.4-0.1,2.1-0.1h470.3c47,0,85-38.1,85-85C612.3,206.1,574.3,168,527.3,168z
		"
            />
          </g>
        </svg>
      </div>
      <div id="full-cloud-5" className="red cloud">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 612 338.2"
        >
          <g>
            <path
              d="M527.3,168c-16.9,0-32.6,5-45.9,13.5c0.5-5.4,0.8-10.9,0.8-16.4C482.2,73.9,409.7,0,320.2,0
		c-72.8,0-134.4,48.9-154.8,116.2c-2.4-0.2-4.8-0.4-7.2-0.4c-57,0-103.2,47.1-103.2,105.2c0,1.8,0.2,3.6,0.3,5.3c-0.1,0-0.2,0-0.3,0
		c-30.3,0-54.9,25-54.9,55.9s24.6,55.9,54.9,55.9c0.7,0,1.4-0.1,2.1-0.1h470.3c47,0,85-38.1,85-85C612.3,206.1,574.3,168,527.3,168z
		"
            />
          </g>
        </svg>
      </div>
      <div id="full-cloud-6" className="cloud">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 612 338.2"
        >
          <g>
            <path
              d="M527.3,168c-16.9,0-32.6,5-45.9,13.5c0.5-5.4,0.8-10.9,0.8-16.4C482.2,73.9,409.7,0,320.2,0
		c-72.8,0-134.4,48.9-154.8,116.2c-2.4-0.2-4.8-0.4-7.2-0.4c-57,0-103.2,47.1-103.2,105.2c0,1.8,0.2,3.6,0.3,5.3c-0.1,0-0.2,0-0.3,0
		c-30.3,0-54.9,25-54.9,55.9s24.6,55.9,54.9,55.9c0.7,0,1.4-0.1,2.1-0.1h470.3c47,0,85-38.1,85-85C612.3,206.1,574.3,168,527.3,168z
		"
            />
          </g>
        </svg>
      </div>
      <div id="cloud-1" className="partial-cloud"></div>
      <div id="cloud-2" className="partial-cloud"></div>
      <div id="tower">
        <div id="top"></div>
        <div id="middle"></div>
        <div id="bottom"></div>
        <div id="bauble"></div>
        <div id="deck"></div>
      </div>
      <div id="hide-overflow">
        <div id="moon"></div>
        <div id="building-1">
          <div className="window"></div>
          <div className="window"></div>
        </div>
        <div id="building-2">
          <div className="window"></div>
        </div>
        <div id="building-3">
          <div className="window" id="one"></div>
          <div className="window" id="two"></div>
        </div>
        <div id="building-4">
          <div className="window"></div>
        </div>
        <div id="building-5"></div>
        <div id="building-6">
          <div className="window" id="top"></div>
          <div className="window" id="bottom"></div>
        </div>
        <div id="building-7">
          <div className="window on"></div>
          <div className="window"></div>
          <div className="window"></div>
          <div className="window on"></div>
          <div className="window on"></div>
        </div>
        <div id="building-8">
          <div className="window"></div>
          <div className="window"></div>
          <div className="window"></div>
        </div>
      </div>
    </div>
  );
};

export default CityBadge;
